import moment from "moment";
import { Div, CollectionView } from "@tblabs/truffle";
import { Order } from "../../../../../Models/Order";
import { StepType } from "../../../../../Steps/Step/StepType";
import { DateTimeProvider } from "../../../../../Services/DateTimeProvider";
import { AddToBasketStepState } from "../../../../../Steps/AddToBasket/Models/AddToBasketStepState";
import { PackageToCustomerStepState } from "../../../../../Steps/PackageToCustomer/Models/PackageToCustomerStepState";
import { PersonalPickupStepState } from "../../../../../Steps/PersonalPickup/Models/PersonalPickupStepState";
import { PersonalReturnStepState } from "../../../../../Steps/PersonalReturn/Models/PersonalReturnStepState";
import { TrainingStepState } from "../../../../../Steps/Training/Models/TrainingStepState";
import { PaymentStepState } from "../../../../../Steps/Payment/Models/PaymentStepState";
import { EventStepState } from "../../../../../Steps/Event/Models/EventStepState";
import { PackageFromCustomerStepState } from "../../../../../Steps/PackageFromCustomer/Models/PackageFromCustomerStepState";
import { Tasks } from "./Tasks";
import { DayTasks } from "./DayTasks";


export class TasksView extends Div
{
    private GroupAndFilter(orders: Order[], filterAndOrder: Partial<Record<StepType, string[]>>): Tasks[]
    {
        const allowedSteps = Object.keys(filterAndOrder);

        const tasks: Tasks[] = [
            ...allowedSteps.map(stepType => new Tasks(stepType as StepType, [])),
        ];

        orders.forEach(order =>
        {
            const step = order.CurrentStep;

            if (!step)
                return;

            if (!allowedSteps.includes(step.Type))
                return;

            const allowedStates = filterAndOrder[step.Type];

            if (!allowedStates?.includes(step.Data.State.value))
                return;

            const task = tasks.find(t => t.StepType === step.Type);

            task?.Orders?.push(order);
        });

        return tasks;
    }

    constructor(private orders: CollectionView<Order>)
    {
        super();

        const openOrders = this.orders.Items.filter(x => x.IsOpen && !x.IsFailed)

        const bags: Record<string, Order[]> = { "today": [], "tomorrow": [], "future": [], "unknown": [] };

        openOrders.forEach(order =>
        {
            const step = order.CurrentStep;

            if (!step)
                return;

            const timeout = moment(step?.Timeout);
            const now = moment(DateTimeProvider.Now);

            if ((timeout.isSame(now, "date")))
            {
                bags.today.push(order);
            }
            else if ((timeout.isSame(now.add(1, "day"), "date")))
            {
                bags.tomorrow.push(order);
            }
            else if ((timeout.isAfter(now.add(1, "day"), "date")))
            {
                bags.future.push(order);
            }
            else
            {
                bags.unknown.push(order);
            }
        });

        const filterAndOrder: Partial<Record<StepType, string[]>> = {
            [StepType.AddToBasket]: [
                AddToBasketStepState.New],
            [StepType.PackageToCustomer]: [
                PackageToCustomerStepState.Planned,
                PackageToCustomerStepState.LabelReady,
                PackageToCustomerStepState.ReadyToShipment,
                PackageToCustomerStepState.AwaitingInPostOffice,
                PackageToCustomerStepState.PackageLost,
                PackageToCustomerStepState.InTransit,
                PackageToCustomerStepState.StillOnTheWay,
            ],
            [StepType.PersonalPickup]: [
                PersonalPickupStepState.PrePlanned],
            [StepType.PersonalReturn]: [
                PersonalReturnStepState.Planned,
                PersonalReturnStepState.TimeToMeet],
            [StepType.Training]: [
                TrainingStepState.Planned,
                TrainingStepState.Planning],
            [StepType.Payment]: [
                PaymentStepState.Awaiting],
            [StepType.PaymentReturn]: [
                PaymentStepState.Awaiting],
            [StepType.Event]: [
                EventStepState.Incoming,
                EventStepState.Preparing],
            [StepType.PackageFromCustomer]: [
                PackageFromCustomerStepState.TimeToSend,
                PackageFromCustomerStepState.OnTheWay],
        };

        const groupedForToday = this.GroupAndFilter(bags.today, filterAndOrder);
        const groupedForTomorrow = this.GroupAndFilter(bags.tomorrow, filterAndOrder);
        const groupedForFuture = this.GroupAndFilter(bags.future, filterAndOrder);
        const groupedForUnknown = this.GroupAndFilter(bags.unknown, filterAndOrder);

        this.Style(`display: flex; flex-direction: row; flex-wrap: wrap; gap: 32px; padding: 16px`).Append(
            new DayTasks("Zaległe", groupedForUnknown),
            new DayTasks("Na dzisiaj", groupedForToday).Background("#e3f8ff"),
            new DayTasks("Na jutro", groupedForTomorrow),
            new DayTasks("Na później", groupedForFuture),
        );
    }
}
